'use client';

import NavbarItem from '@/components/navbar/NavbarItem';
import dict from '@/dictionaries/fa.json';
import {
    CommunityIcon,
    CommunityIconActive,
    EntertainmentIcon,
    EntertainmentIconActive,
    HomeIcon,
    HomeIconActive,
    ProfileIcon,
    ProfileIconActive
} from '@/assets/Icons';
import useIsAndroid from '@/helpers/useIsAndroid';
import useAuth from '@/context/auth/useAuth';
import useMessage from '@/app/(profile)/inbox/services/useMessage';
import React from 'react';
import AppInstallSticky from '@/components/AppInstallSticky';

const NAVBAR_ITEM_ID_PREFIX = 'navbar-item-';

export default function NavbarContainer() {
    const isAndroid = useIsAndroid();
    const { userIsLoggedIn, babyMode } = useAuth();
    const { unreadMessagesCount } = useMessage({ fetchUnreadMessagesCount: userIsLoggedIn });

    if (isAndroid) return;

    return (
        <>
            <AppInstallSticky />
            <nav className="fixed bottom-0 bg-white left-0 right-0 w-full overflow-hidden max-w-[450px] mx-auto h-20 rounded-t-2xl px-8 py-2 shadow-[0px_0px_13px_0px_#00000040] flex items-center justify-between gap-9 z-50">
                <NavbarItem
                    id={NAVBAR_ITEM_ID_PREFIX + 'kids-home'}
                    href={babyMode ? '/babies' : '/'}
                    title={dict.home}
                    icon={<HomeIcon />}
                    active={{
                        icon: <HomeIconActive />,
                        textColor: '#A434EE',
                        bgColor: '#F8F3FC'
                    }}
                />
                {!babyMode && (
                    <>
                        <NavbarItem
                            id={NAVBAR_ITEM_ID_PREFIX + 'community'}
                            href="/community"
                            title={dict.community}
                            icon={<CommunityIcon />}
                            active={{
                                icon: <CommunityIconActive />,
                                textColor: '#DC9E08',
                                bgColor: '#FFF6E1'
                            }}
                        />
                        <NavbarItem
                            id={NAVBAR_ITEM_ID_PREFIX + 'matches'}
                            href="/entertainment"
                            title={dict.entertainment}
                            icon={<EntertainmentIcon />}
                            active={{
                                icon: <EntertainmentIconActive />,
                                textColor: '#0B97F4',
                                bgColor: '#E8F5FE'
                            }}
                        />
                    </>
                )}
                <NavbarItem
                    id={NAVBAR_ITEM_ID_PREFIX + 'profile'}
                    href="/profile"
                    title={dict.account}
                    icon={<ProfileIcon />}
                    showBadge={!!unreadMessagesCount?.count}
                    active={{
                        icon: <ProfileIconActive />,
                        textColor: '#1CC96D',
                        bgColor: '#E8F9F0'
                    }}
                />
            </nav>
        </>
    );
}
